import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
/**
 * @jsxRuntime classic
 * @jsx jsx
 */

import React from 'react';
import { R50, R500, R75, Y50, Y500, Y75, B50, B500, B75, G50, G500, G75, P50, P500, P75, N30A, N800, N40 } from '@atlaskit/theme/colors';
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import { css, jsx } from '@emotion/react';
export var resolveColors = function resolveColors(color) {
  switch (color) {
    case 'red':
      {
        return ["var(--ds-background-accent-red-subtlest, ".concat(R50, ")"), "var(--ds-text-accent-red, ".concat(R500, ")"), "var(--ds-background-accent-red-subtler, ".concat(R75, ")")];
      }
    case 'yellow':
      {
        return ["var(--ds-background-accent-yellow-subtlest, ".concat(Y50, ")"), "var(--ds-text-accent-yellow, ".concat(Y500, ")"), "var(--ds-background-accent-yellow-subtler, ".concat(Y75, ")")];
      }
    case 'blue':
      {
        return ["var(--ds-background-accent-blue-subtlest, ".concat(B50, ")"), "var(--ds-text-accent-blue, ".concat(B500, ")"), "var(--ds-background-accent-blue-subtler, ".concat(B75, ")")];
      }
    case 'green':
      {
        return ["var(--ds-background-accent-green-subtlest, ".concat(G50, ")"), "var(--ds-text-accent-green, ".concat(G500, ")"), "var(--ds-background-accent-green-subtler, ".concat(G75, ")")];
      }
    case 'purple':
      {
        return ["var(--ds-background-accent-purple-subtlest, ".concat(P50, ")"), "var(--ds-text-accent-purple, ".concat(P500, ")"), "var(--ds-background-accent-purple-subtler, ".concat(P75, ")")];
      }
    case 'grey':
    default:
      return ["var(--ds-background-neutral, ".concat(N30A, ")"), "var(--ds-text, ".concat(N800, ")"), "var(--ds-background-neutral-hovered, ".concat(N40, ")")];
  }
};
var baseStyles = css({
  borderRadius: "var(--ds-border-radius, 3px)",
  padding: "var(--ds-space-025, 2px)".concat(" ", "var(--ds-space-050, 4px)"),
  margin: '0 1px',
  position: 'relative',
  transition: 'background 0.3s',
  whiteSpace: 'nowrap'
});
export var DateLozenge = function DateLozenge(props) {
  var colors = resolveColors(props.color);
  if (colors === '') {
    colors = ['', '', ''];
  }
  var _colors = colors,
    _colors2 = _slicedToArray(_colors, 3),
    background = _colors2[0],
    color = _colors2[1],
    hoverBackground = _colors2[2];
  return (
    // eslint-disable-next-line @atlaskit/design-system/no-html-button
    jsx("span", {
      role: "button",
      css: [baseStyles,
      // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
      {
        cursor: props.onClick ? 'pointer' : 'unset',
        background: background,
        color: color,
        '&:hover': {
          background: hoverBackground
        }
      }]
    }, props.children)
  );
};